export default {
  state: {
    title: 'Status',
    visible: 'Tafelbestellen zichtbaar',
    on: 'Tafelbestellen',
  },
  notes: {
    hidden: {
      title: 'Tafelbestellen is verborgen',
      description:
        'Het staat aan, maar je shop toont het niet, dus elke tafelbestelling wordt geweigerd. Zet „Tafelbestellen zichtbaar” aan om het te tonen.',
      link: 'Ga naar de schakelaar',
    },
    off: {
      title: 'Gasten kunnen nu niet aan tafel bestellen',
      description:
        'Zet beide schakelaars aan om te starten. Tot die tijd opent de QR-code van een tafel je shop met Afhalen en Bezorgen.',
    },
    no_active_table: {
      title: 'Gasten kunnen nog niet aan tafel bestellen',
      description: 'Voeg hieronder een tafel toe en zet die aan.',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
};
